export { default as thunk } from 'redux-thunk'
export { default as axios } from './axios'



// WEBPACK FOOTER //
// ./src/services/state/middlewares/index.js